import { render, staticRenderFns } from "./MergeSceneFile.vue?vue&type=template&id=ec4df4fc&scoped=true"
import script from "./MergeSceneFile.vue?vue&type=script&lang=js"
export * from "./MergeSceneFile.vue?vue&type=script&lang=js"
import style0 from "./MergeSceneFile.vue?vue&type=style&index=0&id=ec4df4fc&prod&lang=scss"
import style1 from "./MergeSceneFile.vue?vue&type=style&index=1&id=ec4df4fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4df4fc",
  null
  
)

export default component.exports